import type { PdpConfig } from '#types/config/pages/pdp'
import type { RecursivePartial } from '#types/utils'

export default {
  enableSketchfab: true
} satisfies RecursivePartial<PdpConfig>
